import { ButtonProps } from '@chakra-ui/react'

export const mediaToggleButtonBaseStyles: ButtonProps = {
  border: 'none',
  borderRadius: '0',
  fontSize: '12px',
  fontWeight: '600',
  h: 'auto',
  lineHeight: '1',
  minW: 'auto',
  px: '14px',
  py: '6px',
  _focus: { boxShadow: 'none' },
  _focusVisible: { boxShadow: 'none' },
}

export const mediaToggleSpinnerAnimation = {
  '@keyframes mediaToggleSpin': {
    to: { transform: 'rotate(360deg)' },
  },
  animation: 'mediaToggleSpin 0.8s linear infinite',
}
